import { NgxPermissionsService } from 'ngx-permissions'
import {
  UploadPropertyImageRequest,
  DeletePropertyImageRequest,
} from './../properties.actions'
import { FetchImageTypesRequest } from '@shared/shared.actions'
import {
  getPropertyState,
  getImageTypesState,
  getCreatePropertyState,
} from './../properties.selectors'
import { Map, List } from 'immutable'
import FormTrait from 'src/app/traits/form.trait'
import { ActivatedRoute, Router } from '@angular/router'
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core'
import { Store, select } from '@ngrx/store'
import { Subscription } from 'rxjs'
import jsonToFormData from 'json-form-data'
import { getSettingsState } from '@containers/settings/settings.selectors'

@Component({
  selector: 'app-property-gallery',
  templateUrl: './property-gallery.component.html',
  styleUrls: ['./property-gallery.component.css'],
})
export class PropertyGalleryComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public propertyId: number
  private state$: Subscription
  private imageTypes$: Subscription
  public imageTypes: List<Map<string, any>>
  public isLoading: boolean
  public shouldReload: boolean
  public images: Map<string, any>
  public isReadonly: boolean
  public nextStatus: string
  public hasReadonlyPermission: boolean = false
  private settings$: Subscription
  public imageBasePath: string

  constructor(
    public permissionsService: NgxPermissionsService,
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {
    super()
  }

  ngOnInit() {
    this.propertyId = parseInt(this.route.parent.snapshot.params.id)
    this.hasReadonlyPermission =
      this.permissionsService.getPermissions()['READONLY'] !== undefined
    const getState = this.propertyId ? getPropertyState : getCreatePropertyState

    this.state$ = this.store.pipe(select(getState)).subscribe((state) => {
      this.state = state
      const images = state.getIn(['data', 'images'])
      const imagesMap =
        images &&
        images.toKeyedSeq().mapEntries(function (kv: Map<string, any>) {
          return [kv[1].getIn(['imageType', 'name']), kv[1]]
        })
      this.isLoading = state.get('isLoading')
      this.shouldReload = state.get('shouldReload')
      this.images = imagesMap

      if (this.propertyId) {
        this.isReadonly =
          (this.state.getIn(['data', 'status', 'name']) !== 'DATA_ENTRY' &&
            this.state.getIn(['data', 'status', 'name']) !== 'OBJECTION') ||
          this.hasReadonlyPermission ||
          this.state.getIn(['data', 'status', 'name']) === 'ARCHIVED'
      }
    })

    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.imageBasePath = state.getIn([
          'data',
          'path',
          'PATH_IMAGE_BASE_URL',
        ])
      })

    this.imageTypes$ = this.store
      .pipe(select(getImageTypesState))
      .subscribe((state) => {
        this.imageTypes = state.get('data')
      })

    this.store.dispatch<any>(new FetchImageTypesRequest('property'))
  }

  public upload({ event, imageTypeId }) {
    const file: File = event.target.files[0]
    const payload = jsonToFormData({ file, imageTypeId })
    this.store.dispatch<any>(
      new UploadPropertyImageRequest(this.propertyId, payload),
    )
  }

  public delete({ type }) {
    const imageTypeId = type.get('id')
    this.store.dispatch<any>(
      new DeletePropertyImageRequest(this.propertyId, imageTypeId),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.imageTypes$.unsubscribe()
    this.settings$.unsubscribe()
  }
}
